var React = require('react');

function PlaneIconBlackInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#202020","fillRule":"evenodd","d":"M13.784 0c-.632-.01-1.393.38-2.027 1.014-1.038.934-2.058 1.982-3.04 3.04L.607 2.433 0 3.649l6.081 3.04-3.446 4.054c-.79-.26-2.027-.556-2.027.406 0 .19.048.385.203.608l2.432 2.432c.223.155.418.203.608.203.962 0 .665-1.237.406-2.027L8.31 8.919 11.35 15l1.216-.608-1.621-8.108c1.058-.983 2.106-2.003 3.04-3.04.635-.635 1.024-1.396 1.014-2.028-.006-.34-.113-.665-.331-.885-.22-.218-.545-.325-.885-.33z"}));
}

PlaneIconBlackInline.defaultProps = {"width":"15","height":"15"};

module.exports = PlaneIconBlackInline;

PlaneIconBlackInline.default = PlaneIconBlackInline;
